import qestIds from '../../../QestIds';

const getConfig = (prefix: string) => ({
  [`${prefix}.BouldersPercentage`]: { format: { nearest: 5 } },
  [`${prefix}.CobblesPercentage`]: { format: { nearest: 5 } },
  [`${prefix}.GravelPercentage`]: { format: { nearest: 5 } },
  [`${prefix}.SandPercentage`]: { format: { nearest: 5 } },
  [`${prefix}.FinesPercentage`]: { format: { nearest: 5 } },
});

export { getConfig };

export default {
  [qestIds.soilClassification.ASTM.estimated_Psd]: getConfig,
};
